/* eslint-disable react/function-component-definition */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'

import Hero from '../components/elements/Hero'
import HeroIntro from '../components/elements/HeroIntro'
import AdvantagesGrid from '../components/elements/AdvantagesGrid'
import HeroDetail from '../components/elements/HeroDetail'
import ContentImages from '../components/elements/ContentImages'
import QuoteDefault from '../components/elements/QuoteDefault'
import CtaDefault from '../components/elements/CtaDefault'
import SingleProjectGallery from '../components/elements/SingleProjectGallery'
import Vs from '../components/elements/Vs'

export const pageQuery = graphql`
  query ($id: String) {
    page: wpPage(id: { eq: $id }) {
      title
      uri
      pageDetail {
        headerdetail {
          pretitle
          title
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
          link {
            title
            url
            target
          }
          titleunder
        }
        introdetail {
          title
          description
          extradescription
        }
        advantagesdetail {
          items {
            icon {
              localFile {
                publicURL
              }
            }
            title
          }
          description
          link {
            title
            url
            target
          }
        }
        herodetail {
          description
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
          items {
            title
          }
        }
        contentimagesdetail {
          image {
            localFile {
              publicURL
            }
          }
          items {
            title
            subtitle
            description
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 2000, quality: 100)
                  meta: fluid(maxWidth: 800, toFormat: JPG) {
                    src
                  }
                }
              }
            }
          }
        }
        versusdetail {
          description
        }
        quotedetail {
          quote
        }
        ctadetail {
          description
          link {
            title
            url
            target
          }
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }
        projectdetail {
          title
          imageBig {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
          imageSmall {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
          description
          project {
            ... on WpProject {
              id
              databaseId
              uri
              title
              projectrecap {
                gallerij {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 2000, quality: 100)
                      meta: fluid(maxWidth: 800, toFormat: JPG) {
                        src
                      }
                    }
                  }
                }
              }
            }
          }
          link {
            title
            url
          }
        }
      }

      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublisher
        opengraphPublishedTime
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          sourceUrl
        }
        twitterImage {
          sourceUrl
        }
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { pageDetail, seo, uri },
  },
}) => (
  <Layout subFooter>
    {seo && <SEO seo={seo} />}

    <Hero
      pretitle={pageDetail.headerdetail.pretitle}
      title={pageDetail.headerdetail.title}
      src={pageDetail.headerdetail.image}
    />

    <HeroIntro
      title={pageDetail.introdetail.title}
      description={pageDetail.introdetail.description}
      extradescription={pageDetail.introdetail.extradescription}
      titleunder={pageDetail.headerdetail.titleunder}
      link={pageDetail.headerdetail.link}
    />

    <AdvantagesGrid
      items={pageDetail.advantagesdetail.items}
      description={pageDetail.advantagesdetail.description}
      link={pageDetail.advantagesdetail.link}
    />

    <HeroDetail
      description={pageDetail.herodetail.description}
      image={pageDetail.herodetail.image}
      items={pageDetail.herodetail.items}
    />

    <ContentImages
      image={pageDetail.contentimagesdetail.image}
      items={pageDetail.contentimagesdetail.items}
    />

    <Vs location={uri} description={pageDetail.versusdetail.description} />

    <QuoteDefault quote={pageDetail.quotedetail.quote} />

    <CtaDefault cta={pageDetail.ctadetail} />

    <SingleProjectGallery
      title={pageDetail.projectdetail.title}
      project={
        pageDetail.projectdetail.project
          ? pageDetail.projectdetail.project[0]
          : []
      }
      link={pageDetail.projectdetail.link}
      imageSmall={pageDetail.projectdetail.imageSmall}
      imageBig={pageDetail.projectdetail.imageBig}
      description={pageDetail.projectdetail.description}
    />
  </Layout>
)

export default PageTemplate
